import { EdgeModel } from 'ui/workflows/flowchart/types';
import { Node } from '../../../types';

export type SelectedEdge = {
  data: EdgeModel;
  id: string;
  type: string;
};

type FilterSelectedEdgeProps = {
  currEdge: SelectedEdge;
  currNode: Node;
  selNodes: Node[];
};

export const filterSelectedEdge = ({
  currEdge,
  currNode,
  selNodes,
}: FilterSelectedEdgeProps): boolean => {
  return (
    currEdge.data.target === currNode.id.toString() &&
    selNodes.some((anotherSelEdge) => anotherSelEdge.id.toString() === currEdge.data.source)
  );
};
